import { AuthorizedInstallerApplication } from '@authorizedInstaller/types/authorizedInstallers';
import { Alpha2CountryCode, FormStepList } from '@common/types/common';

// If empty, no filtering occurs
const countryRestrictions: Alpha2CountryCode[] = ['ZA', 'ES', 'AU'];

const applicationFormSteps: FormStepList<AuthorizedInstallerApplication> = [
    {
        title: 'General',
        description:
            'To apply for the authorized installer program, we need some information about you and the company you work for.',
        fields: ['first_name', 'last_name', 'company_name', 'distributor', 'sales_manager'],
    },
    {
        title: 'Contact',
        description:
            'Add contact details so the sales manager can easily contact you for further questions or remarks regarding the application.',
        fields: ['address1', 'city', 'country_code', 'state', 'mobile_phone', 'email'],
    },
    {
        title: 'Upload Certificates',
        description: "Upload any certificates you've achieved over the years to verify your skills as an installer.",
        fields: ['certificate_files'],
    },
    {
        title: 'Upload Installations',
        description: "Upload pictures of installations you've already installed and/or managed.",
        fields: ['installation_files'],
    },
    { title: 'Terms & Agreements', description: 'Terms placeholder, depends on Gijs', fields: ['accept_terms'] },
];

export { applicationFormSteps, countryRestrictions };
